import React from 'react';

import styled from 'styled-components';

import { PlusIcon2, StyledIconV2 } from 'constants/icons';

import { Typography13 } from 'uiToolkit/Typography';

import { useLevelUpContext } from '../context';

const Container = styled.div`
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
`;

const WorkTowardsNewRole = ({ className }) => {
  const { openRoleSelectionModal } = useLevelUpContext();

  return (
    <Container className={className} onClick={() => openRoleSelectionModal({ isNewRoleSelection: true })}>
      <StyledIconV2
        size="fixed10px"
        containerSize="fixed24px"
        circularOutline
        color="primary"
        bgColor="white"
        style={{ flex: '0 0 auto' }}
        rightGutter={1.5}
      >
        <PlusIcon2 />
      </StyledIconV2>
      <Typography13 color="primary">Work towards a new role</Typography13>
    </Container>
  );
};

export default WorkTowardsNewRole;
